import { Packr } from 'msgpackr'

const packr = new Packr({ structuredClone: true })

// prettier-ignore
const names = [
  'snapshot',
  'entityAdded',
  'entityModified',
  'entityRemoved',
  'chunkAdded',
  'chunkRebuilt',
  'chunkRemoved',
  // 'voxelsModified',
  'blockAdded',
  'blockDamage', // server sends to client to update damage amount shown
  'mediaMute',
  'mediaLevel',
  'equip',
  'playerHitBlock', // player client sends to server to damage block
  'editorBreakBlock', // editor client sends to server to break block
  'editorPlaceBlock', // editor client sends to server to place block
  'editVoxels',
  'setEditorBlockIdx',
  'setEditorBlockAtIdx',
  'editAssets',
  'ping',
  'pong',
]

const byName = {}
const byId = {}

let ids = -1

for (const name of names) {
  const id = ++ids
  const info = {
    id,
    name,
    method: `on${capitalize(name)}`, // eg 'connect' -> 'onConnect'
  }
  byName[name] = info
  byId[id] = info
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function writePacket(name, data) {
  const info = byName[name]
  if (!info) throw new Error(`writePacket failed: ${name} (name not found)`)
  const packet = packr.pack([info.id, data])
  return packet
}

export function readPacket(packet) {
  try {
    const [id, data] = packr.unpack(packet)
    const info = byId[id]
    if (!info) throw new Error(`readPacket failed: ${id} (id not found)`)
    return { name: info.name, method: info.method, data }
  } catch (err) {
    console.error(err)
    return []
  }
}
